document.addEventListener("DOMContentLoaded", function() {
  const container = document.querySelector('.collection-scroll-container');
  if (!container) return;

  // Retrieve offset setting passed from Liquid
  const baseOffset = parseInt(container.dataset.stickyOffset) || 0;
  // Add 60px breathing room so title isn't hidden behind nav
  const scrollOffset = baseOffset + 60;

  const navList = container.querySelector('.sub-nav-list');

  // --- Scroll Hint Animation ---
  // Fires once on page load after a short delay, never again until reload
  setTimeout(() => {
    navList.classList.add('io-scroll-hint-active');
    navList.addEventListener('animationend', () => {
      navList.classList.remove('io-scroll-hint-active');
    }, { once: true });
  }, 800);

  // --- Smooth Scroll on Click ---
  const links = container.querySelectorAll('.js-scroll-link');

  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetSection = document.querySelector(targetId);

      if (targetSection) {
        const topPos = targetSection.getBoundingClientRect().top + window.scrollY - scrollOffset;
        window.scrollTo({
          top: topPos,
          behavior: 'smooth'
        });
      }
    });
  });

  // --- Active State + Auto-scroll Nav ---
  const sections = container.querySelectorAll('.collection-row');
  const navItems = container.querySelectorAll('.sub-nav-item');

  function scrollNavToActive(activeLink) {
    if (!navList || !activeLink) return;
    const listPadding = 16; // matches the 16px padding-left on .sub-nav-list
    const targetScrollLeft = activeLink.parentElement.offsetLeft - listPadding;
    navList.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });
  }

  const observerOptions = {
    root: null,
    rootMargin: '-20% 0px -60% 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Remove active class from all
        navItems.forEach(link => link.classList.remove('active'));

        // Add active class to corresponding link
        const id = entry.target.getAttribute('id');
        const activeLink = container.querySelector(`.js-scroll-link[href="#${id}"]`);
        if (activeLink) {
          activeLink.classList.add('active');
          scrollNavToActive(activeLink);
        }
      }
    });
  }, observerOptions);

  sections.forEach(section => {
    observer.observe(section);
  });
});